var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAweful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25761 17.3941C8.25761 18.488 7.36865 19.3769 6.27474 19.3769C5.18083 19.3769 4.29187 18.488 4.29187 17.3941C4.29187 17.2634 4.30468 17.1353 4.3303 17.0123H8.21918C8.2448 17.1353 8.25761 17.2634 8.25761 17.3941Z",
    fill: "#CED5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5525 17.3941C28.5525 18.488 27.6636 19.3769 26.5697 19.3769C25.4758 19.3769 24.5868 18.488 24.5868 17.3941C24.5868 17.2634 24.5996 17.1353 24.6252 17.0123H28.5141C28.5397 17.1353 28.5525 17.2634 28.5525 17.3941Z",
    fill: "#CED5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2045 18.827C12.3619 18.827 8.70687 21.3363 8.70687 25.0206C8.70687 25.7276 9.27995 26.3006 9.98687 26.3006C10.6938 26.3006 11.2669 25.7276 11.2669 25.0206C11.2669 23.279 13.1813 21.387 16.2045 21.387C19.2281 21.387 21.1421 23.2768 21.1421 25.0206C21.1421 25.7276 21.7151 26.3006 22.4221 26.3006C23.129 26.3006 23.7021 25.7276 23.7021 25.0206C23.7021 21.3334 20.0466 18.827 16.2045 18.827Z",
    fill: "#CED5EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2057 16.3411C32.2057 25.1784 25.0417 32.3424 16.2044 32.3424C7.36714 32.3424 0.203125 25.1784 0.203125 16.3411C0.203125 7.50386 7.36714 0.339844 16.2044 0.339844C25.0417 0.339844 32.2057 7.50386 32.2057 16.3411ZM16.2044 30.7424C24.158 30.7424 30.6057 24.2947 30.6057 16.3411C30.6057 8.38752 24.158 1.93984 16.2044 1.93984C8.2508 1.93984 1.80312 8.38752 1.80312 16.3411C1.80312 24.2947 8.2508 30.7424 16.2044 30.7424Z",
    fill: "#CED5EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAweful);
export default __webpack_public_path__ + "static/media/aweful.1bfc7edcde7301eb8b07293b27ea096d.svg";
export { ForwardRef as ReactComponent };